import React from 'react';
import Slider from 'react-slick';
import './PlantationTwoBlog.scss';
import { useCollection } from '../../../../firebase-files/hooks/useCollection';
import { useDocument } from '../../../../firebase-files/hooks/useDocument';
import { useAuthContext } from '../../../../firebase-files/hooks/useAuthContext';
import { useNavigate } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PlantationTwoBlog = () => {
  const { user } = useAuthContext();
  const { document: userData } = useDocument('users', user?.uid);
  const { documents: blogs } = useCollection('blogs_and_articles');
  const navigate = useNavigate();

  const isAdmin = userData?.roles === 'admin';

  const handleSeeMore = () => {
    navigate('/blog-articles');
  };

  const handleCardClick = (id) => {
    navigate(`/blog-details/${id}`);
  };

  const handleAddBlog = () => {
    navigate('/blog-articles');
  };

  const handleDelete = (e, id) => {
    e.stopPropagation();
    console.log('Delete blog with ID:', id);
    // Optional: Add Firebase delete logic here
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: 'linear',
    slidesToShow: 4,
    slidesToScroll: 1,
    pauseOnHover: false,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0px',
        },
      },
    ],
  };

  return (
    <div className="plantation-blog-section">
      <div className="header-row">
        <h2 className="section-title">Blog Posts</h2>
        {isAdmin && (
          <button className="add-blog-btn" onClick={handleAddBlog}>
            ➕ Add Blog
          </button>
        )}
      </div>

      {blogs?.length > 0 ? (
        <Slider {...settings} className="blog-slider">
          {blogs.map((blog) => (
            <div
              className="blog-card"
              key={blog.id}
              onClick={() => handleCardClick(blog.id)}
            >
              <img
                src={blog.imgUrl || '/default-blog.jpg'}
                alt={blog.title || 'Blog Image'}
              />
              <p className="blog-title">{blog.title || 'Untitled Blog'}</p>
              <div
                className="blog-description"
                dangerouslySetInnerHTML={{
                  __html: blog.description || 'No description available.',
                }}
              />
              <div className="blog-footer">
                <span className="blog-date">{blog.date || 'July 25, 2025'}</span>
                <div className="blog-actions">
                  <span className="read-more">👁️ Read More</span>
                  {isAdmin && (
                    <span
                      className="delete-icon"
                      onClick={(e) => handleDelete(e, blog.id)}
                    >
                      🗑️
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      ) : (
        <p className="no-blogs-text">No blogs available.</p>
      )}

      {blogs?.length > 2 && (
        <div className="see-more-container">
          <button className="see-more-btn" onClick={handleSeeMore}>
            See More
          </button>
        </div>
      )}
    </div>
  );
};

export default PlantationTwoBlog;
